export const PrimeQueryKeys = {
    conversation: (id: string) => ["conversation", id],
    allConversations: "conversations",
    createConversation: "createConversation",
    showEmbeddingTextCookie: "prime_show_embedding_text",

    file: (id: string) => ["file", id],
    fileElements: (id: string, page: number) => ["file", id, "elements", page],

    workflowProblems: ["workflow", "problems"],
    workflowCurrentFile: ["workflow", "currentFile"],
    fragmentNode: (id: string) => ["fragment", id],
    relatedFragmentNodes: (id: string, fragmentUuid: string) => [
        "file",
        id,
        "related-fragments",
        fragmentUuid,
    ],
    allFiles: "files",

    adminOverview: ["admin", "overview"],
    adminKgFiles: ["admin", "kg-files"],

    problemPairs: ["workflows", "problems"],

    showDebugInfoCookie: "showDebugInfoCookie",
    emptyConversationHistoryCookie: "noConversations",
};
